import { PauseCircle, PlayCircle } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';
import { useGame } from 'contexts/Game/Game';
import { useEffect, useState } from 'react';

export default function Clock() {

    const [time, setTime] = useState('0:00');
    const game = useGame();

    useEffect(() => {
        const minutes = Math.floor(game.turns / 60);
        const seconds = String(game.turns % 60).padStart(2, '0');
        const newTime = `${minutes}:${seconds}`;
        setTime(newTime);
    }, [
        game.turns
    ]);

    return <Box alignItems="center" bottom={0} display="flex" gap={1} position="fixed" left={32} sx={{ userSelect: 'none' }} zIndex={1100}>
        <IconButton aria-label={game.paused ? 'resume' : 'pause'} onClick={() => game.setPaused(!game.paused)}>
            {game.paused ? (
                <PlayCircle />
            ) : (
                <PauseCircle />
            )}
        </IconButton>
        <Typography color="primary" variant="roboto416">
            {time}
        </Typography>
    </Box>;

}